import { render, staticRenderFns } from "./posCardsPlaceholder.template.vue?vue&type=template&id=3ef1e874&scoped=true&"
var script = {}
import style0 from "./posCardsPlaceholder.template.vue?vue&type=style&index=0&id=3ef1e874&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1e874",
  null
  
)

export default component.exports